/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Check_TabInputs */

const en_check_tab = /** @type {(inputs: Check_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three-way check`)
};

/**
* | output |
* | --- |
* | "Three-way check" |
*
* @param {Check_TabInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const check_tab = /** @type {((inputs?: Check_TabInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_TabInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_check_tab(inputs)
});